import { Inject, Injectable } from '@angular/core';
import { HighContrastTokens, HighContrastMode } from './models/accesibility.model';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AccessibilityService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
  }

  applyHighContrastMode(mode: HighContrastMode) {
    this.document.body.classList.remove(HighContrastTokens.dark.cssClass, HighContrastTokens.light.cssClass);

    const matcher = {
      [HighContrastMode.LIGHT]: () => this.document.body.classList.add(HighContrastTokens.light.cssClass),
      [HighContrastMode.DARK]: () => this.document.body.classList.add(HighContrastTokens.dark.cssClass),
    }

    matcher[mode]?.();
  }
}
